const getProduct = async ({ skuItemName, qty }) => {
  try {
    const target = "InventoryTool/GetInventoryDetailsAndSAPLeadTime?";
    const params = `&skuItemName=${skuItemName}&skuQuantity=${qty}`;

    const response = await fetch(
      process.env.NODE_ENV === "production"
        ? `/ignitionapi/${target}${params}`
        : `http://local.legrandav.com/ignitionapi/${target}customerNumber=0000140823${params}`,
    );

    const data = await response.json();

    return data;
  } catch (error) {
    console.log(`getProduct error: ${error}`);
  }
};

export default getProduct;
